import type { TurnEvent } from "./types";

/**
 * Splits a reply into ordered events and the text the student should see.
 * Port of `LiveFroshBotService.extractMarkers` — the regexes are the Swift
 * originals verbatim, because both ends of this protocol were tuned together.
 */

const TOOL_PATTERN = /\[TOOL:\s*(\w+)(?:\s+(\{[^\]]*\}))?\]/;
const ECHO_PATTERN = /\[(?:RESULT|Context):\s*[^\]]*\]/g;

export function extractMarkers(text: string): { events: TurnEvent[]; clean: string } {
  let remaining = text.replace(ECHO_PATTERN, "");
  const events: TurnEvent[] = [];
  let clean = "";

  for (;;) {
    const match = TOOL_PATTERN.exec(remaining);
    if (!match || match.index === undefined) break;

    const before = remaining.slice(0, match.index);
    if (before.length > 0) {
      events.push({ kind: "text", text: before });
      clean += before;
    }

    const name = match[1];
    let params: Record<string, string> = {};
    if (match[2]) {
      try {
        const parsed = JSON.parse(match[2]) as Record<string, unknown>;
        params = Object.fromEntries(Object.entries(parsed).map(([k, v]) => [k, String(v)]));
      } catch {
        // Malformed params degrade to a bare call, same as the Swift parser.
      }
    }
    events.push({ kind: "tool", name, params });

    remaining = remaining.slice(match.index + match[0].length);
  }

  if (remaining.trim().length > 0) {
    events.push({ kind: "text", text: remaining });
    clean += remaining;
  }

  return { events, clean: clean.trim() };
}
